import { ContentLink, OrderStatus } from '@api/types';
import {
  BlockContainer,
  OrderList,
  OrderListProvider,
  OrderListSearch,
  OrderPageHeader,
} from '@components';
import { Box, styled } from '@mui/material';
import React from 'react';
// STYLES
//--------
const OrderListBlockWrapper = styled(Box)<OrdersBlockProps>`
  padding-bottom: 32px;
`;

// TYPES
//-------
export type OrdersBlockProps = {
  contentLink?: ContentLink;
  title?: string;
  children?: React.ReactNode;
  numberItemsOnPage?: number;
  beremaColumnsDisplayed?: string;
  statusesDefault?: OrderStatus;
  filterBarVisible?: boolean;
  visibleFilters?: string;
  orderTypeDefault?: string;
  dealerColumnsDisplayed?: string;
};

// COMPONENTS
//------------
export const OrderListBlock = ({
  contentLink,
  title,
  numberItemsOnPage,
  statusesDefault: clientStatusDefault,
  orderTypeDefault,
  filterBarVisible,
  visibleFilters,
  dealerColumnsDisplayed,
  beremaColumnsDisplayed,
}: OrdersBlockProps) => {
  // SEARCH & FILTERS - STATE
  //--------------------------
  const id = contentLink?.id?.toString() || '';
  const isFiltersVisible = Boolean(filterBarVisible && visibleFilters);
  return (
    <OrderListProvider
      id={id}
      numberItemsOnPage={numberItemsOnPage}
      beremaColumnsDisplayed={beremaColumnsDisplayed}
      statusesDefault={clientStatusDefault}
      visibleFilters={visibleFilters}
      orderTypeDefault={orderTypeDefault}
      dealerColumnsDisplayed={dealerColumnsDisplayed}
    >
      <BlockContainer>
        <OrderListBlockWrapper className='order-list-block'>
          <OrderPageHeader title={title} />
          {isFiltersVisible ? <OrderListSearch id={id} /> : null}
          <OrderList />
        </OrderListBlockWrapper>
      </BlockContainer>
    </OrderListProvider>
  );
};
